import { Tooltip, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import React from 'react';
import Dashboard from 'types/entities/Dashboard';

const ClientCell = React.memo((row: Dashboard) => (
  <>
    {row?.client_name && (
      <Tooltip title={`${capitalize(row?.client_name)}`}>
        <Typography variant="body2" noWrap>{`${capitalize(row?.client_name)}`}</Typography>
      </Tooltip>
    )}
  </>
));

export default ClientCell;
